// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.withdraw-rules[data-v-2a58826a] {\n  margin-bottom: 14px;\n}\n.withdraw-rules__title[data-v-2a58826a] {\n  font-weight: normal;\n  font-size: 18px;\n}\n.withdraw-rules__item[data-v-2a58826a] {\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
